import type { FeedbackMessages } from './en';

const sw: FeedbackMessages = {
  qualified: {
    title: 'Asante kwa kukamilisha utafiti huu!',
    text: 'Unaweza kufunga dirisha la kivinjari.\n\nTunatarajia kukuona tena hivi karibuni.',
  },
  quotaFull: {
    title: 'Utafiti huu umefungwa',
    text: 'Asante kwa kupendezwa na utafiti wetu.\n\nKwa bahati mbaya, tayari tumepokea majibu yote tunayohitaji.\n\nTunatarajia kukuona katika mojawapo ya utafiti wetu wa siku zijazo!',
  },
  terminated: {
    title: 'Asante kwa kutoa maoni yako!',
    text: 'Tunatarajia kukuona hivi karibuni katika utafiti wetu wa siku zijazo. Hadi wakati huo, tunakutakia siku njema.\n\nTafadhali funga dirisha hili la kivinjari.',
  },
  mismatch: {
    title: 'Asante kwa kupendezwa kwako',
    text: 'Kwa bahati mbaya, hauko katika kundi lengwa kwa utafiti huu maalum.\n\nUnaweza kufunga ukurasa huu.',
  },
  error: {
    title: 'Hatuwezi kushughulikia ombi lako',
    linkProblemDetailed:
      'Kiungo ulichofuata kina matatizo. Tafadhali hakikisha kwamba kiungo kilichopo kwenye sehemu ya anwani kinafanana na kile ulichopewa, kisha jaribu tena.',
    linkProblemGeneric: 'Kiungo ulichofuata kina matatizo. Tafadhali jaribu tena.',
    contactPerson:
      'Iwapo tatizo litaendelea, tafadhali mjulishe mtu uliyempata kiungo kutoka kwake kuhusu tatizo hili.',
  },
};

export default sw;
